import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'decodeUriComponent' })
export class DecodeUriComponentPipe implements PipeTransform {
    transform(url: string) {
        return decodeURIComponent(url);
    }
}

